import React, { type PropsWithChildren } from 'react';

import { NavigationConfirmationEnvironmentContextProvider } from './NavigationConfirmationEnvironment';
import { NavigationConfirmationHandlerContextProvider } from './NavigationConfirmationHandler';
import {
  NavigationConfirmationManagerContext,
  useNavigationConfirmationManager,
} from './useNavigationConfirmationManager';

const RootContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const navigationConfirmationManager = useNavigationConfirmationManager();

  return (
    <NavigationConfirmationHandlerContextProvider>
      <NavigationConfirmationManagerContext.Provider value={navigationConfirmationManager}>
        <NavigationConfirmationEnvironmentContextProvider>
          {children}
        </NavigationConfirmationEnvironmentContextProvider>
      </NavigationConfirmationManagerContext.Provider>
    </NavigationConfirmationHandlerContextProvider>
  );
};

export default RootContextProvider;
